module.exports = __webpack_public_path__ + "img/car.cd245177.png";